import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import * as Sentry from '@sentry/angular';
import { transformEventTitle } from './app/services/sentry/sentry.service';
import { createFaitrackerProxy, installFactorsJsErrorSuppressor } from './app/shared/helpers/faitracker-defense';

const isLocalhost = typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

if (!isLocalhost) {
  Sentry.init({
    dsn: environment.sentryDsn,
    environment: environment.type,
    sendDefaultPii: true,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration()
    ],
    tracesSampleRate: environment.production ? 0.1 : 1.0,
    tracePropagationTargets: ["localhost", /^https:\/\/.*\.sarasanalytics\.com/],
    replaysSessionSampleRate: environment.production ? 0.1 : 1.0,
    replaysOnErrorSampleRate: 1.0,
    beforeSend(event) {
      try {
        return transformEventTitle(event);
      } catch (error) {
        return event;
      }
    },
  });
}

if (environment.production) {
  enableProdMode();
}

if (typeof window !== 'undefined') {
  // FAITRACKER defense: Proxy + error suppressor for the third-party form-tracking
  // library (factors.js) which crashes with `TypeError: Cannot read properties of
  // null (reading 'split')` when form inputs lack id/name attributes.
  // See Sentry DATON-WEBAPP-1B and src/app/shared/helpers/faitracker-defense.ts.
  installFactorsJsErrorSuppressor(window);
  (window as any).FAITRACKER_FORM_FILLS = createFaitrackerProxy();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .then(success => console.log(`Bootstrap success`))
  .catch(err => console.log(err));



